/* eslint-disable no-empty-pattern */
import { instance } from '../../config/axios';
import store from '../index';

const actions = {
  postCheckout(_, data) {
    return new Promise((resolve, reject) => {
      instance().post(`/sellers/${store.state.currentSellerId}/checkouts`, data)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  }
};

export default {
  namespaced: true,
  actions
};